<template>
  <div class="content">
    <base-header class="pb-6 bg-gradient-info">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">
            Kundenangebot rechnen 

            <template v-if="currentAccount.isAdmin">ADMIN</template>
            
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row class="card-wrapper">
        <b-col lg="8" id="main">
          <b-row class="card-wrapper">
            <b-col lg="12">
              <!-- customer data -->
              <customer title="Kundendaten" icon="fas fa-users"></customer>
            </b-col>
          </b-row>

          <b-row class="card-wrapper">
            <template v-if="true">
              <b-col lg="12">
                <!-- car data -->
                <car title="Fahrzeugdaten" icon="fas fa-car" v-if="offer.is_car"></car>
                <van title="Fahrzeugdaten" icon="fas fa-van" v-if="offer.is_van"></van>
              </b-col>
            </template>
          </b-row>

          <b-row class="card-wrapper">
            <template v-if="true">
              <b-col lg="12">
                <!--  versicherung -->
                <insurance
                  title="Informationen zur Versicherung"
                  icon="fas fa-info"
                ></insurance>
              </b-col>
            </template>
          </b-row>

          <b-row class="card-wrapper">
            <template v-if="true">
              <b-col lg="12">
                <!--   options -->
                <options
                  title="Informationen zur Versicherung"
                  icon="fas fa-info"
                ></options>
              </b-col>
            </template>
          </b-row>
        </b-col>
        <b-col lg="4">
          <!-- offerinfo -->
          <calc-info v-if="currentAccount.isAdmin"></calc-info>
          <offer-info v-if="currentAccount.isAdmin"></offer-info>
          <!-- <offer-info v-if="claim.showDamageInfo" v-on:custom="toggleSummary"></offer-info> base-button type="primary" class="btn btn-primary" @click="logValidity()" v-if="allDataValidated()">Speichern und weiter OLD</base-button -->
        </b-col>
        <b-col lg="12">
          <base-button
            type="primary"
            class="btn btn-primary"
            @click="submitToApi()"
            v-if="allDataValidated"
            >Jetzt kalkulieren</base-button
          >
        </b-col>
      </b-row>

      <modal :show.sync="offer.new_car_above_max">
        <h6 slot="header" class="modal-title">
          <i class="fas fa-university"></i>
          Angebot nicht möglich
        </h6>

        <p>
          Bitte kontaktieren sie die TLP-Wirtschaftsberatung um ein Fahrzeug mit
          einem Fahrzeugneuwert > 210.000 € zu versichern.
        </p>

        <template slot="footer">
          <div class="btn-wrapper text-center">
            <base-button type="primary" class="btn btn-info">
              <span
                class="btn-inner--text"
                v-on:click="offer.new_car_above_max = false"
                >OK</span
              >
            </base-button>
          </div>
        </template>
      </modal>
    </b-container>
  </div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import BaseSlider from "@/components/BaseSlider";
import { Modal, BaseAlert } from "@/components";
import swal from "sweetalert2";

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import Customer from "../cscomponents/offer/Customer";
import Car from "../cscomponents/offer/Car";
import Van from "../cscomponents/offer/Van";
import Insurance from "../cscomponents/offer/Insurance";
import Options from "../cscomponents/offer/Options";

/* debug */
import OfferInfo from "../cscomponents/OfferInfo";
import CalcInfo from "../cscomponents/CalcInfo";

import { mapGetters, mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    RouteBreadCrumb,
    BaseSlider,
    Modal,
    Customer,
    Car,
    Van,
    Insurance,
    Options,
    OfferInfo,
    CalcInfo,
  },
  data() {
    return {
      loading: false,
      //token: false,
      offerdata: [],
      modals: {
        notice: false,
        lawyer: false,
        expertise: false,
        damageheight: false,
      },
    };
  },
  props: {
    token: String,
  },
  methods: {
    retrieveOffer(token) {
      console.log("RETREIVING OFFER FOR EDIT");
      this.loading = true;
      this.$api
        .getOffer(token)
        .then((response) => {
          //this.offerdata = response.data.offer;
          //  this.offer = response.data.offer;

          console.log("LOGGING OFFER FOR EDIT");
          console.log(response.data.offer);
          console.log(this.offer);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    nextDialogInWizard() {
      if (this.claim.showCamUpload) {
        return this.showCamUploader();
      }
      if (this.claim.showDamageHeight) {
        return this.showDamageHeightDialog();
      }
      if (this.claim.showLawyer) {
        return this.showLawyerDialog();
      }
    },

    // modals
    showCarValueNotice() {
      this.modals.carvalue = true;
    },

    logValidity() {
      return this.allDataValidated();
      console.log("Validity: lawyer -> " + this.offer.lawyerValidated);
      console.log(
        "Validity: damageheight -> " + this.offer.damageHeightValidated
      );
      console.log("Validity: date -> " + this.offer.desiredDateValidated);
      console.log("Validity: kind -> " + this.offer.damageKindValidated);
      console.log(
        "Validity: customeradd -> " + this.offer.customerAddressValidated
      );
      console.log(
        "Validity: billingadd -> " + this.offer.billingAddressValidated
      );
      console.log(
        "Validity: inspectionadd -> " + this.offer.inspectionAddressValidated
      );
      console.log("Validity: car -> " + this.offer.carDataValidated);
      console.log("Validity: opponent -> " + this.offer.opponentDataValidated);
      console.log("Validity: ALL -> " + this.offer.allValidated);
    },

    customerValidated(){
      console.log("Validity: customer_firstname -> " + this.offer.customer_firstname);
      if(!this.offer.customer_firstname){
        return false;
      }
      console.log("Validity: title -> " + this.offer.title);
      if(!this.offer.title){
        return false;
      }
      console.log("Validity: customer_lastname -> " + this.offer.customer_lastname);
      if(!this.offer.customer_lastname){
        return false;
      }
      console.log("Validity: dob -> " + this.offer.dob);
      if(!this.offer.dob){
        return false;
      }
      console.log("Validity: customer_zip -> " + this.offer.customer_zip);
      if(!this.offer.customer_zip){
        return false;
      }
      console.log("Validity: has_holder -> " + this.offer.has_holder);
      if(!this.offer.has_holder){
        return false;
      }
      return true;
    },
    carValidated(){

    },
    insuranceValidated(){

    },

    allDataValidated: function () {
      if (customerValidated()
         /*
        this.offer.lawyerValidated &&
        this.offer.damageHeightValidated &&
        this.offer.desiredDateValidated &&
        this.offer.damageKindValidated &&
        this.offer.customerAddressValidated &&
        this.offer.billingAddressValidated &&
        this.offer.inspectionAddressValidated &&
        this.offer.carDataValidated &&
        this.offer.opponentDataValidated
        */
      ) {
        this.offer.allValidated = true;
        console.log("VALID WE'RE MOVING");
        return true;
      }
    },

    slogValidity() {
      this.submitToApi();
    },

    // send via apollo
    submitToApi() {
      this.loading = true;
      this.$api
        .createOffer(this.offer)
        .then((response) => {
          //console.log(response);
          //offerId = response.data.id;
          console.log(response.data.id);
          this.$router.push({ path: `/offers/${response.data.id}` });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters({ currentAccount: 'currentAccount' }),
    ...mapState({
      offer: (state) => state.offer,
    }),
    ...mapActions({
      fetchOffer: (state) => state.fetchOffer,
      resetOffer: (state) => state.resetOffer,
    }),

    

    maySave: function () {
      return this.allDataValidated();
    },

    sallDataValidated: function () {
      return true;
    },
  },

  watch: {
    reallyFinished: function () {
      if (this.allDataValidated) {
        this.claim.allValidated = true;
        console.log("VALID WE'RE MOVING");
      }
    },
    moveToSummary: function () {
      if (this.claim.allValidated) {
        console.log("VALID WE'RE MOVING");
        this.toggleSummary();
      }
    },
  },

  mounted: function () {
    if (this.$route.params.token) {
      console.log("GOTTHETOKEN");
      this.$store.dispatch("fetchOffer", this.$route.params.token);

      this.offer.selected_only_driver = true;
      this.offer.selected_free_sfr = true;
      this.offer.selected_second_vehicle = true;
      this.offer.show_usage = true;

    } else {
      if(!this.offer.wizard){
        this.$store.dispatch("resetOffer");
      }
      
      console.log("GOT   NOOOOO       TOKEN");
      this.offer.show_usage = true;
    }

    console.log("ACCOUNT");
    console.log(this.currentAccount);
  },
  created() {},
};
</script>
<style>
</style>